module.exports = __webpack_public_path__ + "media/images/icons/raspberry-pi-06005966aebb4f003892b6a92a4855df.svg";